// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202606082351/js/" + chunkId + "." + {"44":"085db070","225":"d70647ac","481":"3c85b03d","486":"bce17f38","770":"e355ad2b"}[chunkId] + ".0.05201726068515777.chunk.js";
};